module.exports = __webpack_public_path__ + "static/img/banner-m2.3ee7fd44.jpg";